// Google AdSense config. Publisher/slot IDs are public (they ship in page HTML).
export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "ca-pub-2314372466669749";
export const ADS_ENABLED = !!ADSENSE_CLIENT;

export const AD_SLOTS = {
  topLeaderboard: "3714938129",   // CurioVault_Top_Leaderboard
  inFeed1: "6436384518",          // CurioVault_InFeed_1  (after 3rd curio)
  midRect: "9765430441",          // CurioVault_Mid_Rect  (after 9th curio / detail page)
  inFeed2: "1603780106",          // CurioVault_InFeed_2  (after 16th curio)
  footerLeaderboard: "9877111089",// CurioVault_Footer_Leaderboard
};
